import React from 'react';
import Grid from '@material-ui/core/Grid';

import Header from '../../components/utils/Header';
import Version from '../../api/Version';
import VersionForm from './VersionForm';


class VersionCreateView extends React.Component {
  constructor(props) {
    super(props);

    // Makes sure default values are up to date.
    Version.invalidateOptions();

    this.instance = new Version({ id: null });
  }

  render() {
    return (
      <Grid container direction="column" spacing={2} wrap="nowrap">
        <Grid item>
          <Header title="Upload new Input File" />
        </Grid>
        <Grid item>
          <VersionForm instance={this.instance} />
        </Grid>
      </Grid>
    );
  }
}


export default VersionCreateView;
